import { useEffect, useState } from "react";
import axios from "axios";
import { churchInfo, upcomingEvents as mockEvents } from "../mock";
import { MapPin, Phone, Mail, Clock, Calendar, ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Visit() {
  const [events, setEvents] = useState(mockEvents);
  const [info, setInfo] = useState(churchInfo);
  useEffect(() => {
    axios.get(`${API}/events`).then(r => { if (r.data?.length) setEvents(r.data); }).catch(() => {});
    axios.get(`${API}/contact-info`).then(r => { if (r.data) setInfo({ ...churchInfo, ...r.data }); }).catch(() => {});
  }, []);
  return (
    <section id="visit" className="py-24 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <div className="text-[#c8a36a] uppercase tracking-[0.32em] text-xs font-bold mb-3">Plan Your Visit</div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0a2d38] tracking-tight">
            We’ve saved you <span className="text-[#c8a36a]">a seat.</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          <div className="rounded-md overflow-hidden border border-[#e8ecef] h-[480px] bg-white">
            <iframe
              title="Church location"
              src="https://www.google.com/maps?q=310+W+4th+St,+Big+Spring,+TX+79720&output=embed"
              className="w-full h-full"
              loading="lazy"
            />
          </div>

          <div className="space-y-5">
            <div className="bg-white border border-[#e8ecef] rounded-md p-7">
              <h3 className="text-2xl font-bold text-[#0a2d38] mb-5">Find us in Big Spring</h3>
              <div className="space-y-4 text-[#4a5b62]">
                <div className="flex items-start gap-3">
                  <MapPin className="h-5 w-5 text-[#c8a36a] mt-0.5 flex-shrink-0" />
                  <div>
                    <div className="font-bold text-[#0a2d38]">{info.pastors}</div>
                    <div>{info.address}</div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="h-5 w-5 text-[#c8a36a] flex-shrink-0" />
                  <a href={`tel:${info.phoneRaw}`} className="hover:text-[#0a2d38]">{info.phone}</a>
                </div>
                <div className="flex items-center gap-3">
                  <Mail className="h-5 w-5 text-[#c8a36a] flex-shrink-0" />
                  <a href={`mailto:${info.email}`} className="hover:text-[#0a2d38]">{info.email}</a>
                </div>
                <div className="flex items-start gap-3">
                  <Clock className="h-5 w-5 text-[#c8a36a] mt-0.5 flex-shrink-0" />
                  <div>
                    <div>Sundays — 9:45 AM Sunday School · 10:45 AM Worship</div>
                    <div>Wednesdays — 7:00 PM (Children’s Church too)</div>
                  </div>
                </div>
              </div>
              <a href="https://www.google.com/maps?q=310+W+4th+St,+Big+Spring,+TX+79720" target="_blank" rel="noreferrer"
                className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#0a2d38] hover:text-[#c8a36a]">
                Get directions <ArrowUpRight className="h-4 w-4" />
              </a>
            </div>

            <div className="bg-[#0a2d38] text-white rounded-md p-7">
              <div className="flex items-center gap-2 text-[#c8a36a] uppercase tracking-[0.28em] text-xs font-semibold mb-4">
                <Calendar className="h-3.5 w-3.5" /> Upcoming
              </div>
              <ul className="divide-y divide-white/10">
                {events.map((e, i) => (
                  <li key={e.id || i} className="py-3 flex items-center justify-between gap-4">
                    <div>
                      <div className="text-lg font-bold">{e.title}</div>
                      <div className="text-sm text-white/70">{e.location}</div>
                    </div>
                    <div className="text-right text-sm">
                      <div className="text-[#f0d9a8]">{e.date}</div>
                      <div className="text-white/70">{e.time}</div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
